import type { Theme } from "@emotion/react";
import { css } from "@emotion/react";
import { pxToRem } from "../../design/utils";
import type { PageColourOptions } from "./settings/defaults";

export const viewInPublicationCSS = ({ layers, colours }: Theme) => css`
  display: flex;
  align-items: center;
  padding: 2px 6px;
  border: none;
  gap: 2px;
  opacity: 1;
  border-radius: 6px;
  height: 16px;
  ${layers.relief.uiGrey_10.shadowHigher}
  color: ${colours.uIGrey.dark._30};
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0px;
`;

export const publicationCSS = (options?: PageColourOptions) => css`
  overflow-x: auto;
  h1,
  h2,
  h3 {
    position: relative;
  }
  h1 {
    padding-top: 11rem;
  }
  h2 {
    padding-top: 1rem;
  }
  blockquote {
    padding: 0.5rem;
    padding-inline: 1rem;
  }
  #publication-style p {
    margin-top: 0;
    padding-top: 0.5rem;
  }

  a {
    text-decoration: underline;
  }

  table {
    border: 1px solid rgba(224, 224, 230, 1);
    width: max-content;
    max-width: 100%;
    table-layout: auto;
    th,
    td {
      padding: 5px;
      border: 1px solid rgba(224, 224, 230, 1);
      word-wrap: break-word;
      word-break: break-word;
      overflow-wrap: break-word;
      // to prevent large blocks of text breaking the table layout
      max-width: ${pxToRem(500)};
    }
  }
  table.duxbury-table {
    white-space: nowrap;
    overflow-x: scroll;
    display: inline-block;
    tr th:first-child,
    tr td:first-child {
      background-color: ${options?.background ?? "rgba(250, 249, 244, 1)"};
      position: sticky;
      left: 0;
      word-break: normal;
      text-wrap: auto;
    }
  }
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  .footnote-content {
    display: block;
    margin-top: 0.5rem;
    padding: 0.75rem;
    font-weight: 600;
  }

  li .footnote-content,
  table .footnote-content {
    display: inline;
    padding: 0;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    margin-top: 0;
  }

  .footnote-content.hidden {
    display: none !important;
  }

  .footnote-toggle {
    background: none;
    border: none;
    cursor: pointer;
    font-size: ${pxToRem(10)};
    font-weight: 700;
    padding: 0;
  }

  .footnotesHeader {
    font-weight: 700;
    margin-top: 1rem;
  }

  .footnote-toggle-hidden {
    cursor: default;
  }
`;
